import { motion } from "framer-motion";
import "./Example.css";
import { Link } from "react-scroll";

const PhoneAnimation = () => {
  return (
    <section className="example-section">
      <FloatingPhone />
    </section>
  );
};

const FloatingPhone = () => {
  return (
    <div
      style={{
        transformStyle: "preserve-3d",
        transform: "rotateY(-30deg) rotateX(15deg)",
      }}
      className="floating-container"
    >
      {" "}
      {/* This help to rotate the screen of phone */}
      <motion.div
        initial={{
          transform: "translateZ(8px) translateY(-2px)",
        }}
        animate={{
          transform: "translateZ(32px) translateY(-8px)",
        }}
        transition={{
          repeat: Infinity,
          repeatType: "mirror",
          duration: 2,
          ease: "easeInOut",
        }}
        className="phone-body"
      >
        <Screen />
      </motion.div>
    </div>
  );
};

const Screen = () => {
  return (
    <div className="phone-screen">
      <svg
        width="50"
        height="39"
        viewBox="0 0 50 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="logo"
      >
        <path d="M16.4992 2H37.5808L22.0816 24.9729H1L16.4992 2Z"></path>
        <path d="M17.4224 27.102L11.4192 36H33.5008L49 13.0271H32.7024L23.2064 27.102H17.4224Z"></path>
      </svg>
      <Link to="Contact">
        <button className="start-btn">Always up for a chat!</button>
      </Link>
      <div className="bottom-glow" />
    </div>
  );
};

export default PhoneAnimation;
